export default function searchform() {

  $(document).ready(function() {
    $('.search-selectbox select').selectize();
  })

}


// WEBPACK FOOTER //
// ./scripts/modules/searchform.js